<template>
  <div>
    <el-dialog v-el-drag-dialog :visible.sync="dialogVisible" :close-on-click-modal="false"
      :title="disabled ? '详情' : form.pkid ? '编辑' : '新建'" class="adaptationModal" @close="$reset('form')">
      <el-form :disabled="disabled" ref="form" :model="form" :rules="ruleValidate" class="form" label-width="110px"
        v-loading="contentLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item v-if="form.pkid" label="项目编号">
              <el-input v-model="form.projectNo" disabled placeholder="系统自动生成" />
            </el-form-item>
          </el-col>
          <el-col :span="24" style="height: 42px;">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model.trim="form.projectName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目经理" prop="projectMangerId" style="width: 50%;">
              <el-input v-model="form.projectMangerName" placeholder="请选择" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectProjectManger.open()" />
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划开工日期" prop="planBeginDate">
              <el-date-picker v-model="form.planBeginDate" value-format="yyyy-MM-dd" style="width: 100%;" type="date"
                placeholder="选择日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划完工日期" prop="planFinishDate">
              <el-date-picker v-model="form.planFinishDate" value-format="yyyy-MM-dd" style="width: 100%;" type="date"
                placeholder="选择日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际开工日期" prop="beginDate">
              <el-date-picker v-model="form.beginDate" value-format="yyyy-MM-dd" style="width: 100%;" type="date"
                placeholder="选择日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际完工日期" prop="finishDate">
              <el-date-picker v-model="form.finishDate" value-format="yyyy-MM-dd" style="width: 100%;" type="date"
                placeholder="选择日期" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio v-for="item in constant.toSelect(constant.programStatus)" :key="item.value"
                  :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">项目组</el-divider>
        <div>
          <el-button v-if="!disabled" type="primary" @click="$refs.selectProjectTeam.open()">添加</el-button>
          <el-table border :data="form.projectTeamVos" style="width: 100%;margin-top: 15px;">
            <el-table-column prop="name" label="用户名" align="center" />
            <el-table-column prop="userName" label="姓名" align="center" />
            <el-table-column prop="departmentName" label="所属部门" align="center" />
            <el-table-column v-if="!disabled" label="操作" align="center" width="80">
              <template slot-scope="scope">
                <el-button type="danger" @click="form.projectTeamVos.splice(scope.$index, 1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <user-select ref="selectProjectManger" @select="onSelectProjectManger" />
    <user-select ref="selectProjectTeam" @select="onSelectProjectTeam" />
  </div>
</template>

<script>
import constant from "@/util/constant";
import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

export default {
  name: "ProgramEdit",
  components: { UserSelect },
  data() {
    var validatePlanFinishDate = (rule, value, callback) => {
      if (this.form.planFinishDate !== '') {
        if (this.form.planFinishDate < this.form.planBeginDate) {
          callback(new Error('计划完工日期不能小于计划开工日期'));
        } else {
          callback();
        }
      } else {
        if (rule.required) {
          callback(new Error('请选择计划完工日期'));
        } else {
          callback();
        }
      }
    };
    var validateFinishDate = (rule, value, callback) => {
      if (this.form.finishDate !== '') {
        if (this.form.finishDate < this.form.beginDate) {
          callback(new Error('实际完工日期不能小于实际开工日期'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      constant,
      dialogVisible: false,
      contentLoading: false,
      submitLoading: false,
      disabled: false,
      form: {
        pkid: 0,
        projectMangerId: "",
        projectMangerName: "",
        planBeginDate: "",
        planFinishDate: "",
        beginDate: "",
        finishDate: "",
        status: 1,
        projectTeamVos: [],
      },
      ruleValidate: {
        projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        projectMangerId: [{ required: true, message: "请选择项目经理", trigger: "change" }],
        planBeginDate: [{ required: true, message: "请选择计划开工日期", trigger: "change" }],
        planFinishDate: [{ required: true, validator: validatePlanFinishDate, trigger: "change" }],
        finishDate: [{ validator: validateFinishDate, trigger: "change" }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
    };
  },
  methods: {
    open(pkid, disabled) {
      this.form.pkid = pkid;
      this.disabled = disabled;
      this.dialogVisible = true;
      if (pkid) {
        this.getData();
      }
    },

    getData() {
      this.contentLoading = true;
      this.$http.get("basic", `projects/${this.form.pkid}`).then(resp => {
        this.form = resp;
        this.contentLoading = false;
      }).catch(() => {
        this.contentLoading = false;
      })
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "projects", this.form)
            .then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("保存成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    onSelectProjectManger(row) {
      this.form.projectMangerId = row.systemUserID;
      this.form.projectMangerName = row.employeeName;
    },

    onSelectProjectTeam(row) {
      if (!this.form.projectTeamVos.some(item => item.memberId === row.systemUserID)) {
        this.form.projectTeamVos.unshift({
          departmentName: row.departmentName,
          userName: row.employeeName,
          memberId: row.systemUserID,
          name: row.userName
        })
      }
    },
  },
};
</script>
